import { pendingCue, playCue } from '../story/playback';
// リザルト：勝敗、星、EXP・Lvアップ、ドロップ、式神加入、次へ／再挑戦／周回／TOP。
import { BATTLE_CONFIG, CHAR_IDS, EQUIPMENT, ENEMIES, OUGI_SKILL_IDS, OMAMORI, PRODUCT_BY_ID, RARITY_LABEL, SHIKIGAMI, isStageUnlocked, shikiFormName, linePointsGain, newlyUnlocked, skillLines, nextStage, provinceOfStage, provinceStages, recommendedPower, stageLabel, type CharId, type Command } from '@hyakki/core';
import { unlockListHtml } from '../ui/skill-news';
import { api, type SoldSummary } from '../api';
import { bgm, jingle } from '../audio';
import { dexFitStyle, gachaArt, shikiArtHtml, isLoaded, itemFrameCls, itemIconStyle, itemOwnerBadge, loadSheet, portraitHtml, portraitKey } from '../assets';
import { icon } from '../ui/icons';
import { levelInfo } from '../core-bridge';
import { stageById } from '../core-bridge';
import { go, register } from '../router';
import { hasEnt, refreshMe, state } from '../state';
import { esc, fmt, onAct, rewardHtml } from '../ui/dom';
import { openModal, toast } from '../ui/overlay';
import { omDetailHtml, omThumbHtml } from '../ui/omamori-view';
import { errorText } from '../ui/status';
import { getResult, setResult, type ResultData } from './result-store';

/** 勝ったあとの「次へ」：同じ国の未クリアで出撃できる戦場（合戦→本城）、無ければ次の目安、それも無ければ同じ戦場 */
function nextInProvince(stageId: number): number {
  const p = state.profile;
  const prov = provinceOfStage(stageId);
  if (p && prov) {
    const s = provinceStages(prov).find((x) => !((p.progress[String(x)]?.clears ?? 0) > 0) && isStageUnlocked(p, x));
    if (s) return s;
  }
  return (p && nextStage(p)) ?? stageId;
}
import { autoHaulOf, autoRun, dismissAutoRun, lastAutoRun, type AutoRun } from '../autorun';
import { openLinkDialog, takeWinNudge } from '../ui/google-link';
import { demoHaul, playHaul, type HaulPhase } from '../ui/haul-fx';
import { bindCompanionActions } from '../ui/companion';
import { newRecruits, showRecruits } from '../ui/recruit';
import { powerHints, type PowerHint } from '../ui/power-hints';
import { itemInfoDialog } from '../ui/equip-view';
import { DIFF } from './stages';
import { coaching } from '../tutorial/coach';
import type { EquipItem } from '@hyakki/core';

/** 戦果のドロップ（タップで性能を見る） */
let dropItems: EquipItem[] = [];

const RAR: Record<string, string> = { n: '並', r: '良', sr: '優', ssr: '極' };
/** 周回明けのまとめ演出を自動で出したオート周回（同じ周回では1回だけ） */
const haulShown = new WeakSet<AutoRun>();
function playAutoHaul() {
  const h = autoHaulOf(lastAutoRun());
  if (h) void playHaul(h);
}
// 撮影・確認用（開発時だけ）：見本の周回でまとめ演出を再生し、指定の段で止める（例 __haulDemo({ ssr: 2 }, 'ssr')）
if (import.meta.env.DEV)
  (window as unknown as { __haulDemo?: unknown }).__haulDemo = (o: Parameters<typeof demoHaul>[0] = {}, holdAt?: HaulPhase) => playHaul(demoHaul(o), { holdAt });
const RAR_N: Record<string, number> = { n: 1, r: 2, sr: 3, ssr: 4 };
/** 自動売却・所持枠超過で売った数と銭（battle/finish の applied）。0個なら出さない */
const soldOf = (s: SoldSummary | undefined) => (s && s.count > 0 ? s : undefined);

register('result', {
  title: 'リザルト',
  full: true,
  nav: 'stages',
  mount(el) {
    const r = getResult();
    if (!r) {
      go('stages', {}, true);
      return;
    }
    if (r.storyEligible && r.server?.firstClear && !r.local && r.result.win && r.difficulty === 0) {
      const cue = pendingCue(r.stageId, 'after');
      if (cue) { playCue(cue, 'result'); return; }
    }
    // 勝ち＝戦果の曲（勝利ジングルが終わってから）、負け＝拠点の曲。レベルが上がったらジングルを足す
    void bgm(r.result.win ? 'result' : 'home');
    const lvB = r.server?.levelBefore;
    const lvA = typeof r.server?.level === 'number' ? r.server.level : r.server?.level?.level;
    if (lvB != null && lvA != null && lvA > lvB) void jingle('levelup');
    draw(el, r);
    // ゲスト：勝ったら Google 連携をすすめる（最初の勝利と、あとは1日1回。オート周回中は出さない）
    // 案内（ユズハ）・ほかの小窓が出ている間は待ち、重ねない
    if (r.result.win && !r.local && !autoRun() && takeWinNudge()) {
      let tries = 0;
      const nudge = () => {
        if (!el.isConnected) return;
        if ((coaching() || document.querySelector('.modal-wrap, .hf')) && ++tries < 240) return void setTimeout(nudge, 500);
        openLinkDialog('win', '勝利の記録を守りませんか？ゲストのデータは、この端末のブラウザにだけ保存されています。');
      };
      setTimeout(nudge, 1200);
    }
    // オート周回が止まって来たとき：まとめ演出を自動で（あとから「もう一度見る」）
    const run = lastAutoRun();
    // 周回のあいだに仲間になった式神は、周回を止めずに、終わったここでまとめ（リザルト）の前に小窓
    if (run?.endedAt && !haulShown.has(run)) {
      haulShown.add(run);
      const joinedInRun = Object.keys(run.gains.shiki).filter((id) => run.gains.shiki[id] > 0);
      void showRecruits(joinedInRun).then(() => playAutoHaul());
    }
    // 式神が仲間に：「仲間になりたそうにこちらを見ている」の小窓（1つの結果に1回）→ 紙吹雪（全体チャットにはサーバーが流す）
    // （オート周回は周回が終わったとき、精算・掃討はまとめの前に出している。ここは手動の戦闘の分）
    void showRecruits(newRecruits(r.server?.rewards ? [r.server.rewards] : []));
    // 式神加入の「連れていく」（変えたら描き直す）
    const offComp = bindCompanionActions(el, () => el.isConnected && draw(el, getResult() ?? r));
    if (!isLoaded(portraitKey(r.charId))) void loadSheet(portraitKey(r.charId)).then(() => el.isConnected && draw(el, getResult() ?? r));
    const off = onAct(el, {
      // 勝ったら次の目安（同じ国の次の戦場を優先）、負けたら同じ戦場
      next: () => go('stages', { stage: r.result.win ? nextInProvince(r.stageId) : r.stageId }),
      retry: () => go('battle', { stage: r.stageId, char: r.charId, diff: r.difficulty }),
      loop: () => go('battle', { stage: r.stageId, char: r.charId, diff: r.difficulty }),
      top: () => go('top'),
      bossoffer: () => go('shop', { cat: 'limited', focus: 'gacha10_boss', from: 'boss_offer' }),
      enhance: () => go('chara'),
      phgo: (b) => {
        const t = phTargets[Number(b.dataset.i)];
        if (t) go(t.screen, t.params);
      },
      skills: () => go('skills'),
      skillpt: (b) => go('chara', { c: b.dataset.c!, tab: 'skill' }),
      resend: async (b) => {
        (b as HTMLButtonElement).disabled = true;
        try {
          const raw = localStorage.getItem('hk.finish');
          const p = raw ? (JSON.parse(raw) as { sessionId: string; commands: Command[] }) : null;
          if (!p) throw new Error('none');
          const server = await api.battleFinish(p.sessionId, p.commands);
          localStorage.removeItem('hk.finish');
          await refreshMe().catch(() => {});
          const next: ResultData = { ...r, server, result: server.result, error: undefined };
          setResult(next);
          draw(el, next);
        } catch (e) {
          (b as HTMLButtonElement).disabled = false;
          toast(errorText(e), 'error');
        }
      },
      autoagain: () => go('stages', { stage: r.stageId }),
      haul: () => playAutoHaul(),
      omview: (b) => {
        const o = getResult()?.server?.rewards?.omamori?.[Number(b.dataset.i)];
        if (o) openModal(omDetailHtml(o), { title: 'お守り', className: 'sheet-wrap' });
      },
      drop: (b) => {
        const i = Number(b.dataset.i);
        const it = dropItems[i];
        if (it) itemInfoDialog(it, it.id < 0 ? '売却済み（所持品には入っていません）' : '');
      },
    });
    return () => {
      off();
      offComp();
      dismissAutoRun(); // オート周回のまとめは一度見せたら消す
    };
  },
});

/** オート周回が止まったときのまとめ */
function autoRunHtml(): string {
  const run = lastAutoRun();
  if (!run?.endedAt) return '';
  const mins = Math.max(1, Math.round((run.endedAt - run.startedAt) / 60_000));
  const g = run.gains;
  const ssr = g.items.filter((d) => d.rarity === 'ssr').length;
  const lvUp = run.end.level > run.start.level;
  const pwUp = run.start.power != null && run.end.power != null && run.end.power > run.start.power ? run.end.power - run.start.power : 0;
  return `<section class="ar-summary" aria-label="オート周回のまとめ">
    <h3 class="sec-title">${icon('auto')}オート周回<small>${esc(run.stopReason ?? '停止しました')}</small><button class="btn small ar-haul" data-act="haul">${icon('present')}もう一度見る</button></h3>
    <div class="ar-grid">
      <div><span>戦闘</span><b>${run.battles}</b><small>${run.wins}勝 ${run.losses}敗・${mins}分${g.stars ? `・星+${g.stars}` : ''}</small></div>
      <div><span>主Lv</span><b>${lvUp ? `${run.start.level}→${run.end.level}` : run.end.level}</b><small>EXP +${fmt(g.exp)}</small></div>
      <div><span>戦力</span><b>${run.end.power != null ? fmt(run.end.power) : '—'}</b>${pwUp ? `<small>+${fmt(pwUp)}</small>` : ''}</div>
      <div><span><i class="ri ri-zeni"></i>銭</span><b>+${fmt(g.zeni)}</b></div>
      <div><span><i class="ri ri-zaimoku"></i>材木</span><b>+${fmt(g.zaimoku)}</b></div>
      <div><span>装備</span><b>${g.drops}</b>${ssr ? `<small class="ar-ssr"><em class="rar ssr">極</em>${ssr}</small>` : ''}</div>
    </div>
    ${run.log.length ? `<ol class="ar-log">${run.log
      .slice(0, 8)
      .map((l) => {
        const st = stageById(l.stageId);
        return `<li class="${l.win ? 'win' : 'lose'}"><b>${l.win ? '勝' : '敗'}</b><span>${st ? esc(stageLabel(st.id, { short: true })) : l.stageId}</span><small>EXP+${fmt(l.exp)}</small></li>`;
      })
      .join('')}</ol>` : ''}
  </section>`;
}

function draw(el: HTMLElement, r: ResultData) {
  // オート周回が終わったときは周回のまとめだけ（最後の1戦の報酬と並べると食い違って見えるため）
  const arOnly = !!lastAutoRun()?.endedAt;
  const st = stageById(r.stageId);
  const res = r.result;
  const sv = r.server;
  const rw = sv?.rewards;
  const lvBefore = sv?.levelBefore;
  const lvAfter = typeof sv?.level === 'number' ? sv.level : sv?.level?.level;
  const lvUp = lvBefore != null && lvAfter != null && lvAfter > lvBefore;
  const firstStars = new Set(rw?.firstStars ?? []);
  // 同じ式神が2回加入（★2つ）しても1つにまとめる
  const recruited = [...new Map((rw?.shikigami ?? []).filter((s) => s.recruited).map((s) => [s.enemyId + (s.dup ? ':dup' : ''), s])).values()];
  const once = sv?.oneTime ?? [];
  const refunded = sv?.refunded ?? rw?.staminaRefund ?? 0;
  const lv = levelInfo(state.resources.exp ?? 0, state.profile);
  const lvPct = lv?.need ? Math.min(100, (lv.into / lv.need) * 100) : 100;
  const conds = ['クリア', '戦闘不能なし', '龍脈をすべて占領'];
  const drops = rw?.equipment ?? [];
  // 所持品に入らなかったドロップ（自動売却・所持枠超過）に「売却」の印。applied.items と defId・レアリティで突き合わせる
  const kept = new Map<string, number>();
  for (const it of sv?.applied?.items ?? []) kept.set(`${it.defId}:${it.rarity}`, (kept.get(`${it.defId}:${it.rarity}`) ?? 0) + 1);
  const soldDrop = drops.map((d) => {
    if (!sv?.applied) return false;
    const k = `${d.defId}:${d.rarity}`;
    const n = kept.get(k) ?? 0;
    if (n > 0) kept.set(k, n - 1);
    return n <= 0;
  });
  // タップで性能を見る：所持品に入ったものはその装備（いまの強化も反映）、売却されたものはドロップの中身から
  const keptItems = [...(sv?.applied?.items ?? [])];
  dropItems = drops.map((d, i) => {
    const j = soldDrop[i] ? -1 : keptItems.findIndex((it) => it.defId === d.defId && it.rarity === d.rarity);
    const got = j >= 0 ? keptItems.splice(j, 1)[0] : null;
    const live = got && state.profile?.items.find((x) => x.id === got.id);
    if (live || got) return live ?? got!;
    const def = EQUIPMENT[d.defId];
    return { id: -1, defId: d.defId, slot: def?.slot ?? 'weapon', charId: def?.charId ?? null, tier: def?.tier ?? 1, rarity: d.rarity, level: 0, lb: 0, affixes: d.affixes ?? [], rerolls: 0, rerollDay: '', ...(d.set ? { set: d.set } : {}), ...(d.shin ? { shin: true } : {}) };
  });
  const autoSold = soldOf(sv?.applied?.autoSold);
  const overSold = soldOf(sv?.applied?.overflowSold);
  el.innerHTML = `
    <div class="page fill result-page">
      <section class="panel-paper deco result ${res.win ? 'win' : 'lose'}">
        <header class="screen-head"><h1 class="screen-title">${arOnly ? 'オート周回' : '戦闘結果'}</h1></header>
        <div class="result-body">
          <div class="res-figure">${portraitHtml(r.charId, 'res-img')}</div>
          <div class="res-main">
            ${arOnly ? autoRunHtml() : `<div class="res-verdict" aria-label="${res.win ? '勝利' : '敗北'}"><span>${res.win ? '勝利' : '敗北'}</span></div>
            <p class="res-stage"><span>${esc(st ? stageLabel(st.id) : '')}${r.difficulty ? `・${DIFF[r.difficulty] ?? ''}` : ''}</span></p>
            <ul class="res-conds">${conds
              .map((t, i) => `<li class="${res.stars[i] ? 'on' : ''}" style="animation-delay:${0.2 + i * 0.2}s"><i class="ck">${icon(res.stars[i] ? 'check' : 'close')}</i>${t}${firstStars.has(i) ? '<em class="tag red">初</em>' : ''}</li>`)
              .join('')}</ul>
            <div class="res-exp">
              <div class="re-row"><b>主EXP</b>${rw?.exp != null ? `<b class="plus">+${fmt(rw.exp)}</b>` : ''}</div>
              ${expPartsHtml(rw?.expParts)}
              <div class="re-row"><span>主Lv. <b class="lvn">${lv?.level ?? '—'}</b></span><div class="meter"><i style="width:${lvPct}%"></i></div></div>
              ${lvUp ? `<p class="lvup">${icon('sp')}レベルアップ！ Lv.${lvBefore} → Lv.${lvAfter}</p>${pointsGainHtml(lvBefore!, lvAfter!, r.charId)}${unlockedHtml(lvBefore!, lvAfter!)}${newlyUnlocked(lvBefore!, lvAfter!).some((s) => OUGI_SKILL_IDS.includes(s.id)) ? ougiLearnHtml() : ''}` : `<p class="nx">次のレベルまで <b>${lv?.need ? fmt(Math.max(0, lv.need - lv.into)) : '—'}</b></p>`}
            </div>
            ${
              sv
                ? `<div class="res-rewards">
                    <h3 class="sec-title">獲得報酬</h3>
                    <div class="rr-grid">
                      ${rw?.zeni ? `<span class="rr"><i class="ri ri-zeni"></i>銭<b>+${fmt(rw.zeni)}</b></span>` : ''}
                      ${rw?.zaimoku ? `<span class="rr"><i class="ri ri-zaimoku"></i>材木<b>+${fmt(rw.zaimoku)}</b></span>` : ''}
                      ${rw?.reidama ? `<span class="rr"><i class="ri ri-reidama"></i>霊玉<b>+${fmt(rw.reidama)}</b></span>` : ''}
                      ${refunded ? `<span class="rr"><i class="ri ri-hyoro"></i>兵糧返却<b>${refunded}</b></span>` : ''}
                      ${autoSold ? `<span class="rr sold"><i class="ri ri-zeni"></i>自動売却 ${autoSold.count}個<b>+${fmt(autoSold.zeni)}</b></span>` : ''}
                      ${overSold ? `<span class="rr sold"><i class="ri ri-zeni"></i>所持枠超過で売却 ${overSold.count}個<b>+${fmt(overSold.zeni)}</b></span>` : ''}
                    </div>
                    ${
                      drops.length || recruited.length
                        ? `<div class="rr-items">${drops.length && hasEnt('drop2x') ? '<span class="sd-drop2 rr-boost">装備ドロップ2倍</span>' : ''}${drops
                            .map(
                              (d, i) =>
                                `<button type="button" class="rr-item r${RAR_N[d.rarity] ?? 1}${soldDrop[i] ? ' sold' : ''}" data-act="drop" data-i="${i}" style="animation-delay:${0.5 + i * 0.12}s" aria-label="${esc(EQUIPMENT[d.defId]?.name ?? d.defId)}の性能">
                                  <span class="thumb ${itemFrameCls(d.defId, d.rarity)}" style="${itemIconStyle(d.defId)}"><em class="rar ${d.rarity}">${RAR[d.rarity] ?? ''}</em>${itemOwnerBadge(d.defId)}${d.affixes?.length ? `<i class="rr-af">${'◆'.repeat(d.affixes.length)}</i>` : ''}</span><small>${esc(EQUIPMENT[d.defId]?.name ?? d.defId)}${soldDrop[i] ? '<em class="rr-sold">売却</em>' : ''}</small></button>`,
                            )
                            .join('')}${recruited
                            .map(
                              (s) =>
                                // 式神図鑑と同じ絵・名前（今の★の姿。仲間になったばかりは★1）
                                `<span class="rr-item shiki"><span class="thumb"><span class="dex-fit" style="${dexFitStyle(s.enemyId, shikiStarNow(s.enemyId))}">${shikiArtHtml(s.enemyId, 60, shikiStarNow(s.enemyId))}</span></span><small>${esc(SHIKIGAMI[s.enemyId] ? shikiFormName(s.enemyId, shikiStarNow(s.enemyId)) : (ENEMIES[s.enemyId]?.name ?? s.enemyId))}<em class="rr-join">式神加入</em></small></span>`,
                            )
                            .join('')}</div>`
                        : ''
                    }
                    ${rw?.omamori?.length ? `<div class="rr-items rr-om">${rw.omamori.map((o, i) => `<button type="button" class="rr-item om" data-act="omview" data-i="${i}" aria-label="${esc(OMAMORI[o.defId]?.name ?? o.defId)}の詳細"><span class="thumb">${omThumbHtml(o, { size: 'm' })}</span><small>${esc(OMAMORI[o.defId]?.name ?? o.defId)}</small></button>`).join('')}</div>` : ''}
                    ${rw?.chests?.length ? `<p class="rr-chests">${icon('present')}宝箱 ${rw.chests.length}個：${rw.chests.map((c) => (c.loot === 'zeni' ? `銭+${fmt(c.zeni ?? 0)}` : c.loot === 'reidama' ? `霊玉+${c.reidama ?? 0}` : c.loot === 'omamori' ? 'お守り' : '装備')).join('・')}</p>` : ''}
                    ${once.length ? `<ul class="once-list">${once.map((o) => `<li><em class="tag">${esc(onceLabel(o.source))}</em>${rewardHtml(o.grants ?? o.bundle)}${o.omamori?.length ? `<span class="small">お守り：${o.omamori.map((x) => (typeof x === 'string' ? esc(OMAMORI[x]?.name ?? x) : `${esc(OMAMORI[x.defId]?.name ?? x.defId)}（${esc(RARITY_LABEL[x.rarity as 'n'] ?? '')}）`)).join('、')}</span>` : ''}</li>`).join('')}</ul>` : ''}
                    ${bossOfferHtml(once)}
                    ${rw?.dex?.length ? `<p class="small muted">図鑑に ${rw.dex.length}体 載りました</p>` : ''}
                  </div>`
                : r.local
                  ? '<p class="muted">端末だけの試合のため、報酬はありません（開発用）。</p>'
                  : `<div class="state-box error">${icon('info')}<p>${esc(r.error ?? '戦果を送れませんでした。')}</p><button class="btn" data-act="resend">戦果を再送する</button></div>`
            }
            ${res.win ? '' : powerHintHtml(r)}`}
          </div>
        </div>
        <div class="result-actions">
          ${res.win && r.stageId < 100 ? `<button class="btn primary big" data-act="next">${icon('sortie')}次へ${icon('right', 'chev')}</button>` : `<button class="btn primary big" data-act="retry">${icon('auto')}もう一度${icon('right', 'chev')}</button>`}
          ${res.win ? `<button class="btn big" data-act="loop">${icon('auto')}もう一度${icon('right', 'chev')}</button>` : `<button class="btn big" data-act="enhance">${icon('enhance')}強化${icon('right', 'chev')}</button>`}
          ${lastAutoRun()?.endedAt ? `<button class="btn big" data-act="autoagain">${icon('auto')}周回設定</button>` : ''}
          <button class="btn big" data-act="top">${icon('home')}TOP${icon('right', 'chev')}</button>
        </div>
      </section>
    </div>`;
}

/**
 * 負けたとき、戦力が推奨戦力に届いていなければ育て方の案内。霊玉で式神Lv を上げられるならそれを先に出す
 * （霊玉をガチャだけに使うと終盤で届きにくい。BALANCE.md 17章）
 */
function powerHintHtml(r: ResultData): string {
  const p = state.profile;
  if (!p || r.local) return '';
  const rec = recommendedPower(r.stageId, r.difficulty);
  const { hints, all, now } = powerHints(p, r.charId, { zeni: state.resources.zeni ?? 0, reidama: state.resources.reidama ?? 0 });
  if (now >= rec) return '';
  const top = hints.slice(0, 3);
  const list = top.length
    ? `<ul class="ph-list">${top
        .map(
          (h, i) =>
            `<li><button class="ph-opt" data-act="phgo" data-i="${i}"><span class="ph-t"><b>${esc(h.title)}</b>${h.sub ? `<small>${esc(h.sub)}</small>` : ''}</span><span class="ph-pw">${fmt(now)}<i>→</i><b class="${h.after >= rec ? 'ok' : ''}">${fmt(Math.round(h.after))}</b></span>${icon('right', 'chev')}</button></li>`,
        )
        .join('')}</ul>${top.length > 1 && all > top[0].after + 0.5 ? `<p class="ph-all">全部行うと戦力 <b class="${all >= rec ? 'ok' : ''}">${fmt(Math.round(all))}</b></p>` : ''}`
    : '<p class="ph-none">兵糧を集めて主Lvを上げる・おまもりガチャでお守りを増やすと戦力が上がります。</p>';
  phTargets = top.map((h) => h.to);
  return `<div class="res-hint ph">${icon('info')}<p>推奨戦力に届いていません（戦力 <b>${fmt(now)}</b>／推奨 ${fmt(rec)}）</p>${list}</div>`;
}
let phTargets: PowerHint['to'][] = [];

/** 章ボスを初めて倒した結果：討伐記念10連（24時間）の1行。ゲストは買えないので出さない */
function bossOfferHtml(once: { source: string }[]) {
  const until = state.profile?.bossOffer?.until ?? 0;
  if (state.me?.user.guest || until <= Date.now() || !once.some((o) => o.source.startsWith('boss_first:'))) return '';
  const p = PRODUCT_BY_ID.gacha10_boss;
  if (!p) return '';
  return `<button type="button" class="res-offer" data-act="bossoffer"><span class="ro-art" style="${gachaArt.omamori}"></span><b>${esc(p.name)}</b><small>あと${Math.floor((until - Date.now()) / 3_600_000)}時間</small><span class="ro-price">¥${fmt(p.yen)}</span>${icon('right', 'chev')}</button>`;
}

/** 主Lvが上がって妖力の奥義のスキルが解放された（スキルで装着すると使える） */
function ougiLearnHtml() {
  const list = Object.values(BATTLE_CONFIG.surge.ougi.chars);
  return `<div class="ougi-learn"><b>${icon('sp')}奥義のスキルが解放されました</b>
    <p>各キャラの専用ツリーのいちばん上の「奥義」を装着すると使えます。妖力が参のとき、メダリオンを長押しすると術ボタンが奥義ボタンに変わります。放つと妖力は壱に戻ります。</p>
    <span class="ol-list">${list.map((o) => `<span><b>${esc(o.name)}</b><small>${esc(o.desc)}</small></span>`).join('')}</span></div>`;
}

/** 主EXPの内訳（上乗せがあるときだけ）：基本＋EXP2倍（基本と同じ量）＋寄進（基本の20%）＋初回クリア */
function expPartsHtml(x: { base: number; paid: number; kishin: number; first: number } | undefined) {
  if (!x || !(x.paid || x.kishin || x.first)) return '';
  const chip = (cls: string, k: string, v: number) => (v ? `<span class="ep ${cls}">${k}<b>${cls === 'base' ? '' : '+'}${fmt(v)}</b></span>` : '');
  return `<div class="re-parts">${chip('base', '基本', x.base)}${chip('paid', 'EXP2倍', x.paid)}${chip('kishin', '寄進', x.kishin)}${chip('first', '初回クリア', x.first)}</div>`;
}

/** 仲間の式神の今の★（無ければ1） */
const shikiStarNow = (id: string) => Math.max(1, state.profile?.shikigami?.[id]?.star ?? 1);

/** レベルアップで増えたスキルポイント（系統のキャラ）。押すとそのキャラのスキル */
function pointsGainHtml(before: number, after: number, used: CharId) {
  const p = state.profile;
  // 出撃したキャラのスキルへ（系統の無いキャラなら系統のある最初のキャラ）
  const c = skillLines(used) ? used : CHAR_IDS.find((x) => skillLines(x));
  const gain = p && c ? linePointsGain(p, before, after) : 0;
  if (!gain) return '';
  return `<button class="skill-unlock sp-gain" data-act="skillpt" data-c="${c}"><b>${icon('sp')}スキルポイント +${gain}</b>${icon('right', 'chev')}</button>`;
}

/** レベルアップで新しく解放されたスキル（共通＋4人の専用） */
function unlockedHtml(before: number, after: number) {
  const list = newlyUnlocked(before, after);
  if (!list.length) return '';
  return `<button class="skill-unlock" data-act="skills"><b>${icon('sp')}新しいスキルが解放されました</b><span class="su-list">${unlockListHtml(list, 5)}</span>${icon('right', 'chev')}</button>`;
}

/** 一度きりの報酬の出どころ（star:12:3 / dex:e007 / boss_first:10 / starbox:… / dexbox:…） */
function onceLabel(source: string) {
  const [k, a, b] = source.split(':');
  if (k === 'star') return `星${b ?? ''}の初回`;
  if (k === 'dex') return `図鑑：${ENEMIES[a]?.name ?? a}`;
  if (k === 'boss_first') return '章ボス初撃破';
  if (k === 'starbox') return '星の累計';
  if (k === 'dexbox') return '図鑑の累計';
  return '初回';
}

